var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M7.192 12.93a5.744 5.744 0 0 1-5.737-5.738 5.744 5.744 0 0 1 5.737-5.737 5.744 5.744 0 0 1 5.737 5.737 5.744 5.744 0 0 1-5.737 5.737m5.57-1.196a7.16 7.16 0 0 0 1.622-4.542C14.384 3.226 11.157 0 7.192 0S0 3.226 0 7.192s3.227 7.192 7.192 7.192c1.721 0 3.302-.61 4.541-1.622l3.025 3.025a.726.726 0 1 0 1.03-1.028z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;